import React from 'react';
import { Layout } from 'antd';
import Header from './Header';

const { Content } = Layout;

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header />
      
      <Content
        style={{
          background: '#f0f2f5',
          minHeight: 'calc(100vh - 64px)',
        }}
      >
        {children}
      </Content>
    </Layout>
  );
};

export default MainLayout;
